export const suggestions = [
  {
    isRough: false,
    isDisplayOption: true,
    key: 'price',
    title: 'Price is',
    options: ['Affordable', 'Fair', 'Expensive'],
    displayOptions: ['Affordable', 'Good Value', 'Premium'],
    value: 0,
    name: 'popularPriceSuggestion',
    uiName: 'price',
    apiName: 'priceSuggestion',
  },
  {
    isYesNo: true,
    choiceOutput: 'Public Transport',
    key: 'location',
    title: 'Is this place accessible by public transport',
    options: ['Yes', 'No'],
    value: 0,
    name: 'popularLocationSuggestion',
    uiName: 'location',
    apiName: 'locationSuggestion',
  },

  {
    isYesNo: true,
    choiceOutput: 'Pleasant Experience',
    key: 'pleasantXP',
    title: 'Was the service experience pleasant',
    options: ['Yes', 'No'],
    value: 0,
    name: 'popularPleasantXPSuggestion',
    uiName: 'pleasant experience',
    apiName: 'pleasantXPSuggestion',
  },
  {
    isRough: true,
    key: 'responseTime',
    title: 'Response time was good',
    options: ['fast', 'slow', 'average'],
    value: 0,
    name: 'popularResponseTimeSuggestion',
    uiName: 'response time',
    apiName: 'responseTimeSuggestion',
  },

  {
    isYesNo: true,
    choiceOutput: 'Acceptable Portion',
    key: 'portionSize',
    title: 'Did you find the portion size acceptable',
    options: ['Yes', 'No'],
    value: 0,
    name: 'popularPortionSizeSuggestion',
    uiName: 'portion size',
    apiName: 'portionSizeSuggestion',
  },
  {
    isRough: true,
    key: 'when',
    title: 'When do people eat this',
    options: ['breakfast', 'lunch', 'brunch', 'dinner', 'supper'],
    value: 0,
    name: 'popularWhenDoPeopleEatThisSuggestion',
    uiName: 'when do people eat this',
    apiName: 'whenDoPeopleEatThisSuggestion',
  },
  {
    isRough: true, //rough means just show the choice
    key: 'dietaryNeeds',
    title: 'Dietary needs',
    options: ['halal', 'vegan'],
    value: 0,
    name: 'popularDietaryNeedSuggestion',
    uiName: 'dietary need',
    apiName: 'dietaryNeedSuggestion',
  },
];
